var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJitsi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 14H13V15H3V14Z",
    fill: "#66798F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11.5H9.5V14.5H6.5V11.5Z",
    fill: "#839CB2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12V14H7V12H9ZM10 11H6V15H10V11Z",
    fill: "#66798F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2.5H15.5V12.5H0.5V2.5Z",
    fill: "#F2FAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3V12H1V3H15ZM16 2H0V13H16V2Z",
    fill: "#788B9C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.535 11.5C4.779 9.805 6.24 8.5 8 8.5C9.76 8.5 11.221 9.806 11.465 11.5H4.535Z",
    fill: "#8BB7F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9C9.304 9 10.416 9.836 10.829 11H5.171C5.584 9.836 6.696 9 8 9ZM8 8C5.791 8 4 9.791 4 12H12C12 9.791 10.209 8 8 8Z",
    fill: "#4E7AB5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.5C7.60218 4.5 7.22064 4.65804 6.93934 4.93934C6.65804 5.22064 6.5 5.60218 6.5 6C6.5 6.39782 6.65804 6.77936 6.93934 7.06066C7.22064 7.34196 7.60218 7.5 8 7.5C8.39782 7.5 8.77936 7.34196 9.06066 7.06066C9.34196 6.77936 9.5 6.39782 9.5 6C9.5 5.60218 9.34196 5.22064 9.06066 4.93934C8.77936 4.65804 8.39782 4.5 8 4.5Z",
    fill: "#FFEEA3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5C8.551 5 9 5.449 9 6C9 6.551 8.551 7 8 7C7.449 7 7 6.551 7 6C7 5.449 7.449 5 8 5ZM8 4C6.895 4 6 4.895 6 6C6 7.105 6.895 8 8 8C9.105 8 10 7.105 10 6C10 4.895 9.105 4 8 4Z",
    fill: "#BA9B48"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.733 11.2H12.266V11.733H3.733V11.2Z",
    fill: "#788B9C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.5H9.5V12.5H6.5V10.5Z",
    fill: "#C2E8FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11V12H7V11H9ZM10 10H6V13H10V10Z",
    fill: "#788B9C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.5H12.5V12.5H9.5V10.5Z",
    fill: "#C2E8FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11V12H10V11H12ZM13 10H9V13H13V10Z",
    fill: "#788B9C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 10.5H6.5V12.5H3.5V10.5Z",
    fill: "#C2E8FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11V12H4V11H6ZM7 10H3V13H7V10Z",
    fill: "#788B9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJitsi);
export default __webpack_public_path__ + "static/media/jitsi.389a5de10d2b8ec5c86b00b4d68e05dc.svg";
export { ForwardRef as ReactComponent };